import { UserFeatures } from 'types/users.types';
import useGetCurrentCustomerData from './Authentication/useGetCurrentCustomerData';

export const useIsFeatureEligible = (feature: UserFeatures): boolean => {
  const { data: user } = useGetCurrentCustomerData();
  return !!user?.featureFlags?.includes?.(feature);
};

export const useIsMinFinDocEligible = (): boolean => {
  return useIsFeatureEligible(UserFeatures.MMF_Docs as UserFeatures);
};
